export function settingsBreadcrumbs(currentLabel = null) {
    const breadcrumbs = [
        {
            label: _mft('navigation:backOffice.sidebar.settings.title'),
            url: route('settings.index'),
        },
    ];

    if (currentLabel) {
        breadcrumbs.push({label: currentLabel});
    }

    return breadcrumbs;
}

export function settingsBreadcrumbsForKey(currentLabelKey = null) {
    return settingsBreadcrumbs(currentLabelKey ? _mft(currentLabelKey) : null);
}
